import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  MenuItem,
  Paper,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import SearchIcon from "@mui/icons-material/Search";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import "dayjs/locale/vi";

import invoiceApi from "../api/invoiceApi";
import invoiceTemplateApi from "../api/invoiceTemplateApi";
import { Table } from "antd";

const searchType = [
  { value: 0, label: "Theo ngày" },
  { value: 1, label: "Theo tháng" },
  { value: 2, label: "Theo quý" },
  { value: 3, label: "Theo năm" },
];

const pageNo = "InvoiceReconciliationReportPage";
function InvoiceReconciliationReportPage() {
  const customerInfor = useSelector((state) => state.auth.customerInfor);
  const [invoices, setInvoices] = useState([]);
  const [summary, setSummary] = useState({
    TotalRevenue: 0,
    TotalAllGtgt: 0,
    TotalAllTncn: 0,
  });
  const [type, setType] = useState(0);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [month, setMonth] = useState(null);
  const months = Array.from({ length: 12 }, (_, i) => i + 1);
  const [quarter, setQuarter] = useState(null);
  const quarters = [
    { value: 1, label: "Quý 1 (Tháng 1 - 3)" },
    { value: 2, label: "Quý 2 (Tháng 4 - 6)" },
    { value: 3, label: "Quý 3 (Tháng 7 - 9)" },
    { value: 4, label: "Quý 4 (Tháng 10 - 12)" },
  ];
  const quarterAll = [
    { value: -1, label: "Cả năm" },
    { value: 1, label: "Quý 1 (Tháng 1 - 3)" },
    { value: 2, label: "Quý 2 (Tháng 4 - 6)" },
    { value: 3, label: "Quý 3 (Tháng 7 - 9)" },
    { value: 4, label: "Quý 4 (Tháng 10 - 12)" },
  ];
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(null);
  const years = Array.from(
    { length: currentYear - 1900 + 1 },
    (_, index) => 1900 + index,
  ).reverse();
  const [symbol, setSymbol] = useState(null);
  const [currentTab, setCurrentTab] = useState(0);
  const [invoiceTemplate, setInvoiceTemplate] = useState([]);

  const GetSalesRevenueReport = async (exportType) => {
    try {
      let dateFrom = fromDate;
      let dateTo = toDate;
      if (type === 1) {
        dateFrom = dayjs()
          .set("year", year)
          .set("month", month - 1)
          .startOf("month");
        dateTo = dayjs()
          .set("year", year)
          .set("month", month - 1)
          .endOf("month");
      }
      if (type === 2) {
        switch (quarter) {
          case 1:
            dateFrom = dayjs().set("year", year).set("month", 0).set("date", 1);
            dateTo = dayjs().set("year", year).set("month", 2).set("date", 31);
            break;
          case 2:
            dateFrom = dayjs().set("year", year).set("month", 3).set("date", 1);
            dateTo = dayjs().set("year", year).set("month", 5).set("date", 30);
            break;
          case 3:
            dateFrom = dayjs().set("year", year).set("month", 6).set("date", 1);
            dateTo = dayjs().set("year", year).set("month", 8).set("date", 30);
            break;
          case 4:
            dateFrom = dayjs().set("year", year).set("month", 9).set("date", 1);
            dateTo = dayjs().set("year", year).set("month", 11).set("date", 31);
            break;
          default:
            break;
        }
      }
      if (type === 3) {
        dateFrom = dayjs().set("year", year).set("month", 0).set("date", 1);
        dateTo = dayjs().set("year", year).set("month", 11).set("date", 31);
      }

      if (exportType === 0) {
        const response = await invoiceApi.GetInvoiceSummaryReport(
          false,
          dateFrom,
          dateTo,
          customerInfor.CusId,
          symbol === "-1" ? null : symbol,
        );
        if (response.success) {
          setInvoices(response.data.Invoices);
          setSummary(response.data.Summary);
        } else {
          toast.error(response.message);
          setInvoices([]);
          setSummary({
            TotalInvoice: 0,
            TotalInvoiceSync: 0,
            TotalInvoiceSign: 0,
            TotalItemAmount: 0,
            TotalDiscountAmount: 0,
            TotalBeforeTax: 0,
            TotalVatAmount: 0,
            TotalAfterTax: 0,
          });
        }
      } else {
        const response = await invoiceApi.GetSalesRevenueReport(
          false,
          dateFrom,
          dateTo,
          customerInfor.CusId,
          exportType,
        );
        if (response.success) {
          setInvoices(response.data.details);
          setSummary({
            TotalRevenue: response.data.totalRevenue || 0,
            TotalAllGtgt: response.data.totalAllGtgt || 0,
            TotalAllTncn: response.data.totalAllTncn || 0,
          });
        } else {
          toast.error(response.message);
          setInvoices([]);
          setSummary({
            TotalRevenue: 0,
            TotalAllGtgt: 0,
            TotalAllTncn: 0,
          });
        }
      }
    } catch (error) {
      toast.error(error);
      setInvoices([]);
      if (exportType === 0) {
        setSummary({
          TotalInvoice: 0,
          TotalInvoiceSync: 0,
          TotalInvoiceSign: 0,
          TotalItemAmount: 0,
          TotalDiscountAmount: 0,
          TotalBeforeTax: 0,
          TotalVatAmount: 0,
          TotalAfterTax: 0,
        });
      } else {
        setSummary({
          TotalRevenue: 0,
          TotalAllGtgt: 0,
          TotalAllTncn: 0,
        });
      }
    } finally {
    }
  };
  const ExportInvoiceReport = async (exportType) => {
    try {
      let dateFrom = fromDate;
      let dateTo = toDate;
      if (type === 1) {
        dateFrom = dayjs()
          .set("year", year)
          .set("month", month - 1)
          .startOf("month");
        dateTo = dayjs()
          .set("year", year)
          .set("month", month - 1)
          .endOf("month");
      }
      if (type === 2) {
        switch (quarter) {
          case 1:
            dateFrom = dayjs().set("year", year).set("month", 0).set("date", 1);
            dateTo = dayjs().set("year", year).set("month", 2).set("date", 31);
            break;
          case 2:
            dateFrom = dayjs().set("year", year).set("month", 3).set("date", 1);
            dateTo = dayjs().set("year", year).set("month", 5).set("date", 30);
            break;
          case 3:
            dateFrom = dayjs().set("year", year).set("month", 6).set("date", 1);
            dateTo = dayjs().set("year", year).set("month", 8).set("date", 30);
            break;
          case 4:
            dateFrom = dayjs().set("year", year).set("month", 9).set("date", 1);
            dateTo = dayjs().set("year", year).set("month", 11).set("date", 31);
            break;
          default:
            break;
        }
      }
      if (type === 3) {
        dateFrom = dayjs().set("year", year).set("month", 0).set("date", 1);
        dateTo = dayjs().set("year", year).set("month", 11).set("date", 31);
      }
      if (exportType > 2) {
        toast.error("Mẫu chưa có sẵn");
        return;
      }
      let response = {};
      if (exportType === 0) {
        response = await invoiceApi.GetInvoiceSummaryReport(
          true,
          dateFrom,
          dateTo,
          customerInfor.CusId,
          symbol === "-1" ? null : symbol,
        );
      } else {
        response = await invoiceApi.GetSalesRevenueReport(
          true,
          dateFrom,
          dateTo,
          customerInfor.CusId,
          exportType,
        );
      }
      console.log(response);

      const binaryData = response.data; // Lấy phần nội dung nhị phân

      if (
        !(binaryData instanceof Blob) &&
        !(binaryData instanceof ArrayBuffer)
      ) {
        toast.error("Lỗi xử lý dữ liệu!");
        console.error("Dữ liệu không phải nhị phân! Kiểm tra responseType.");
      }

      const blob = new Blob([binaryData]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const current = {};
      link.setAttribute("download", current.label + "." + current.fileType);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error(error);
    } finally {
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
      <Container maxWidth="xxl" sx={{ mt: 2, mb: 2 }}>
        <Grid container spacing={2}>
          <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
            <Grid container spacing={1} sx={{ mb: 4 }}>
              <Grid size={{ xs: 12, md: 2 }} sx={{ minWidth: 150 }}>
                <TextField
                  select
                  label="Lọc theo"
                  fullWidth
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  size="small"
                >
                  {searchType.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              {type === 0 && (
                <>
                  <Grid size={{ xs: 12, md: 2 }} sx={{ minWidth: 150 }}>
                    <DatePicker
                      label="Từ ngày"
                      value={fromDate}
                      onChange={(val) => setFromDate(val)}
                      format="DD/MM/YYYY"
                      slotProps={{
                        textField: { fullWidth: true, size: "small" },
                      }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 2 }} sx={{ minWidth: 150 }}>
                    <DatePicker
                      label="Đến ngày"
                      value={toDate}
                      onChange={(val) => setToDate(val)}
                      format="DD/MM/YYYY"
                      slotProps={{
                        textField: { fullWidth: true, size: "small" },
                      }}
                    />
                  </Grid>
                </>
              )}
              {type === 1 && (
                <Grid size={{ xs: 12, md: 2 }} sx={{ minWidth: 150 }}>
                  <TextField
                    select
                    label="Tháng"
                    fullWidth
                    value={month}
                    onChange={(e) => setMonth(e.target.value)}
                    size="small"
                    align="center"
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          style: {
                            maxHeight: 180,
                          },
                        },
                      },
                    }}
                  >
                    {months.map((m) => (
                      <MenuItem key={m} value={m}>
                        Tháng {m}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}
              {type === 2 && (
                <Grid size={{ xs: 12, md: 2 }} sx={{ minWidth: 150 }}>
                  <TextField
                    select
                    label="Quý"
                    fullWidth
                    value={quarter}
                    onChange={(e) => setQuarter(e.target.value)}
                    size="small"
                  >
                    {quarters.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}
              {type !== 0 && (
                <Grid size={{ xs: 12, md: 2 }} sx={{ minWidth: 150 }}>
                  <TextField
                    select
                    label="Năm"
                    fullWidth
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                    size="small"
                    align="center"
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          style: {
                            maxHeight: 180,
                          },
                        },
                      },
                    }}
                  >
                    {years.map((y) => (
                      <MenuItem key={y} value={y}>
                        {y}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}
              {currentTab === 0 && (
                <Grid size={{ xs: 12, md: 2 }} sx={{ minWidth: 150 }}>
                  <TextField
                    select
                    label="Ký hiệu hoá đơn"
                    fullWidth
                    value={symbol || "-1"}
                    onChange={(e) =>
                      setSymbol(e.target.value === -1 ? null : e.target.value)
                    }
                    size="small"
                  >
                    {invoiceTemplate.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}
              <Grid size={{ xs: 12, md: 4 }}>
                <Stack direction="row" spacing={1}>
                  <Button
                    variant="contained"
                    startIcon={<SearchIcon />}
                    sx={{ px: 3, minWidth: 141 }}
                    onClick={() => GetSalesRevenueReport(currentTab)}
                  >
                    Tìm kiếm
                  </Button>
                  {currentTab === 0 ? (
                    <Button
                      variant="outlined"
                      color="success"
                      startIcon={<FileDownloadIcon />}
                      onClick={() => ExportInvoiceReport(currentTab)}
                      sx={{ minWidth: 141 }}
                    >
                      Xuất Excel
                    </Button>
                  ) : (
                    <>
                      <Button
                        variant="outlined"
                        color="success"
                        startIcon={<FileDownloadIcon />}
                        onClick={() => ExportInvoiceReport(currentTab)}
                        sx={{ minWidth: 141 }}
                      >
                        Xuất PDF
                      </Button>
                    </>
                  )}
                </Stack>
              </Grid>
            </Grid>
          </Paper>
          <Grid>
            <TextField sx={{ width: "100px" }} />
          </Grid>
        </Grid>
      </Container>
    </LocalizationProvider>
  );
}
export default InvoiceReconciliationReportPage;
